export default {
    state: {
        menu: [
            { product: true, title: 'Financial Close', bgcolor: 'caccounting' },
            // { button: true, title: 'Create Analysis', href: '/tds/ar#add' },
            // {
            //   title: 'Dashboard', icon: 'mdi mdi-view-dashboard-outline', href: '/pbc/dashboard',
            // },
            {
                title: 'Projects', icon: '/img/navicon/AllProjects.svg', href: '/bookclosure/list',
            },
        ],
    },
    mutations: {
    },
    actions: {
    },
    getters: {

    },
}